import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        user: undefined,
        version: '1.0.1',
        menu: true
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        }, 
        setUser(state, user) {
            state.user = user;
        },
        setVersionserver(state, versionserver) {
            state.versionserver = versionserver;
        },
        toggleMenu(state, menu){
            state.menu = menu;
        }
    },
    actions: {

    }
})
